// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-ui-parts-templates-article-tsx": () => import("./../src/ui_parts/templates/Article.tsx" /* webpackChunkName: "component---src-ui-parts-templates-article-tsx" */),
  "component---src-ui-parts-templates-category-tsx": () => import("./../src/ui_parts/templates/Category.tsx" /* webpackChunkName: "component---src-ui-parts-templates-category-tsx" */)
}

